import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import '../../App.css';
import TextBorder from './TextBorder';
import { Grid } from '@mui/material';
import { Height } from '@mui/icons-material';



export function AnimatedText({Text, componentType, charDelay, AnimateGradient, endAdornment=<></>, useGradient=true}) {
    

    let [state, setState] = useState({
        index: 0,
        maxLength: Text.length,
        currentText: "",
        animationComplete: false
    });

    const [finished, setFinished] = useState(false);
    
    
    
    const textShadow = [
        "0 0 35px 2px #ec407a",
        "0 0 15px #ab47bc",
        "0 0 30px #9c27b0",
        "0 0 45px #8e24aa",
    ];

    const gradientStyle = useGradient? 'rotateBgGradient' : "";
    useEffect(() => {

        let intervalID = setInterval(() => {
                
            setState(prev => {

                // console.log('gradient', prev.gradientStyle.backgroundImage);
                let newIndex = prev.index + 1;
                let isFinished =  newIndex > prev.maxLength;
                
                if (isFinished) {
                    clearInterval(intervalID);
                    setFinished(true);
                    return prev;
                }

                let newText = prev.currentText + Text[prev.index];
                return {
                    ...prev,
                    currentText: newText,
                    index: newIndex,
                    animationComplete: isFinished
                };

            })
        }, charDelay)

        return () => clearInterval(intervalID);
    }, [])

    return (
        <Box
            display={"flex"}
            justifyContent={"center"}
            alignContent={"center"}
        >
            <Typography 
                className={gradientStyle} 
                variant={componentType}
                sx={{
                    textShadow: textShadow,
                    fontWeight: "light",
                    "-webkit-background-clip": "text",
                    "-webkit-text-fill-color": "transparent"
                }}
            >
                {state.currentText}
                { finished && (endAdornment) }
            </Typography>
            <TextBorder hide={finished}/>
        </Box>
    )
}